module.exports = __webpack_public_path__ + "img/guide_music_btn4.b767c830.png";